import React from 'react';
import { useState, useEffect } from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { PauseCircleOutline as PauseIcon, PlayCircleOutline as PlayIcon } from '@mui/icons-material';
import api, { SYMBOL_CONTROL } from '../../../infrastructure/config/api';

const SymbolControlButton = ({ symbol, size = 'medium', onStatusChange }) => {
  const [isSkipped, setIsSkipped] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const { data } = await api.get(SYMBOL_CONTROL.STATUS(symbol));
        if (data?.data?.status) {
          setIsSkipped(data.data.status[symbol] === true);
        }
      } catch (error) {
        console.error('Error fetching symbol status:', error);
      }
    };

    fetchStatus();
  }, [symbol]);

  const handleToggle = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const action = isSkipped ? 'start' : 'skip';
      await api.post('/api/symbol-control/skip', {
        symbol,
        action
      });

      const newStatus = !isSkipped;
      setIsSkipped(newStatus);

      if (onStatusChange) {
        onStatusChange(symbol, newStatus);
      }
    } catch (error) {
      console.error('Error updating symbol status:', error);
    } finally {
      setLoading(false);
    }
  };

  const buttonText = isSkipped ? 'Resume Trading' : 'Pause Trading';
  const icon = isSkipped ?
    <PlayIcon color="primary" fontSize={size} /> :
    <PauseIcon color="action" fontSize={size} />;

  return (
    <Tooltip title={buttonText} arrow>
      <span>
        <IconButton
          onClick={handleToggle}
          disabled={loading}
          size={size}
          color={isSkipped ? 'primary' : 'default'}
        >
          {loading ? <CircularProgress size={24} /> : icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default SymbolControlButton;
